document.addEventListener('DOMContentLoaded', async () => {

    document.addEventListener("variant:updated", (event) => {
        if (!event.detail || !event.detail.variantId || !window.originalVariantsData) return;

        const variant = getVariantById(window.originalVariantsData, event.detail.variantId);

        const priceSelectors = [
            ".summary-side-panel .price .price__container",
            ".price-mob-container .price .price__container"
        ];
        for (const selector of priceSelectors) {
            const priceContainer = document.querySelector(selector);
            if (!priceContainer) {
                continue;
            }

            // Get DOM elements and price values
            const priceSaving = priceContainer.querySelector('span.price-saving');
            const rrpPrice = priceContainer.querySelector('span.rrp');
            const rrpPriceLabel = priceContainer.querySelector('span.rrp-label');
            const rrp = variant.rrpPrice;
            const price = variant.price;

            // Update RRP display if available
            if (rrp && rrp > 0 && rrpPrice) {
                rrpPrice.innerHTML = `&pound; ${rrp / 100}`;
                rrpPriceLabel.innerText = 'New RRP';

                // Show or hide savings based on price comparison
                if (priceSaving) {
                    if (rrp > price) {
                        const savingsPercentage = Math.round((rrp - price) / rrp * 100);
                        if (savingsPercentage > 0) {
                            priceSaving.innerText = `-${savingsPercentage}%`;
                            priceSaving.classList.remove('hidden');
                            rrpPrice.classList.add('rrp-price-line-through');
                        }
                    } else {
                        priceSaving.classList.add('hidden');
                        rrpPrice.classList.remove('rrp-price-line-through');
                    }
                }
            }
        }
    });
});
